import { frontendURL } from '../../../../helper/URLHelper';
import { ISSUE_PERMISSIONS } from 'dashboard/constants/permissions.js';

import IssuesIndex from './Index.vue';
import CreateStepWrap from './Create/Index.vue';
import EditStepWrap from './Edit/Index.vue';
import CreateIssue from './Create/CreateIssue.vue';
import EditIssue from './Edit/EditIssue.vue';
import AddAgents from './Create/AddAgents.vue';
import EditAgents from './Edit/EditAgents.vue';
import FinishSetup from './FinishSetup.vue';
import SettingsContent from '../Wrapper.vue';
import SettingsWrapper from '../SettingsWrapper.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/issues'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: to => {
            return { name: 'settings_issues_list', params: to.params };
          },
        },
        {
          path: 'list',
          name: 'settings_issues_list',
          component: IssuesIndex,
          meta: {
            permissions: ['administrator', ISSUE_PERMISSIONS],
          },
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/settings/issues'),
      component: SettingsContent,
      props: () => {
        return {
          headerTitle: 'ISSUES_SETTINGS.HEADER',
          icon: 'people-issue',
          showBackButton: true,
          backUrl: { name: 'settings_issues_list' },
        };
      },
      children: [
        {
          path: 'new',
          component: CreateStepWrap,
          children: [
            {
              path: '',
              name: 'settings_issues_new',
              component: CreateIssue,
              meta: {
                permissions: ['administrator', ISSUE_PERMISSIONS],
              },
            },
            {
              path: ':issueId/finish',
              name: 'settings_issues_finish',
              component: FinishSetup,
              meta: {
                permissions: ['administrator', ISSUE_PERMISSIONS],
              },
            },
            {
              path: ':issueId/agents',
              name: 'settings_issues_add_agents',
              meta: {
                permissions: ['administrator', ISSUE_PERMISSIONS],
              },
              component: AddAgents,
            },
          ],
        },
        {
          path: ':issueId/edit',
          component: EditStepWrap,
          children: [
            {
              path: '',
              name: 'settings_issues_edit',
              component: EditIssue,
              meta: {
                permissions: ['administrator', ISSUE_PERMISSIONS],
              },
            },
            {
              path: 'agents',
              name: 'settings_issues_edit_members',
              component: EditAgents,
              meta: {
                permissions: ['administrator', ISSUE_PERMISSIONS],
              },
            },
            {
              path: 'finish',
              name: 'settings_issues_edit_finish',
              meta: {
                permissions: ['administrator', ISSUE_PERMISSIONS],
              },
              component: FinishSetup,
            },
          ],
        },
      ],
    },
  ],
};
